<template>
  <div>
    <nav class="links-wrapper__nav">
      <div class="links-wrapper__title-box">
        <div
          class="links-wrapper__title"
          @click="displayContent"
        >
          {{ title }}
          <img
            :class="{ 'links-wrapper__title-arrow--rotated' : active === title }"
            src="~/assets/images/icons/i-arrow-left-dark.svg"
            class="links-wrapper__title-arrow"
          />
        </div>
      </div>
    </nav>
    <CollapseTransition>
      <ul
        v-show="active === title"
        class="links-wrapper__list"
      >
        <li
          v-for="link in links"
          :key="link.name"
          class="links-wrapper__list-item"
        >
          <span
            v-if="isAppName(link.name)"
            class="links-wrapper__list-item-link"
          >
            App
          </span>
          <a
            :href="link.path"
            :target="link.targetBlank ? '_blank' : '_self'"
            :rel="link.rel ? 'noopener noreferrer' : ''"
            class="links-wrapper__list-item-link"
          >
            {{ isAppName(link.name) ? 'Quero Bolsa' : link.name }}
          </a>
        </li>
      </ul>
    </CollapseTransition>
  </div>
</template>

<style lang="sass" scoped>

  @import '~/assets/stylesheets/utils/module.sass'

  .links-wrapper__title-box
    @media (min-width: $screen-sm-min)
      margin-left: auto
      margin-right: auto
      max-width: 540px
      padding-left: $space-m
      padding-right: $space-m

  .links-wrapper__nav
    background-color: $bottombar-bg
    border-bottom: 1px solid $footer-color
    padding: $space-s $space-m

  .links-wrapper__title
  	color: $footer-color
  	font-size: rem(15)
  	font-weight: $fw-bold

  .links-wrapper__title-arrow
    float: right
    height: 9px
    margin-right: 9px
    margin-top: 6px
    transform: rotate(-90deg)
    transition-duration: 0.5s
    vertical-align: middle
    width: 6px

  .links-wrapper__title-arrow--rotated
    transform: rotate(90deg)

  .links-wrapper__list
    list-style: none
    max-width: 540px
    margin-bottom: 0
    margin-left: auto
    margin-right: auto
    padding-left: $space-m
    padding-right: $space-m

  .links-wrapper__list-item
    padding-bottom: $space-xs
    padding-top: $space-xs

  .links-wrapper__list-item-link
    color: $footer-color
    font-size: rem(13)
    line-height: rem(13)
    text-decoration: none

    &:hover
      text-decoration: none
      color: $white

</style>

<script>
  import { CollapseTransition } from 'vue2-transitions';

  export default {
    components: {
      CollapseTransition,
    },
    props: {
      active: {
        type: String,
        required: true,
      },
      links: {
        type: Array,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
    methods: {
      isAppName(name) {
        return name === 'App';
      },
      displayContent() {
        if (this.active === this.title) {
          this.$emit('display', '');
        } else {
          this.$emit('display', this.title);
        }
      }
    },
  }
</script>
